// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const Settings = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width={size}
      height={size}
      fill={fill || "none"}
      stroke={stroke}
      strokeWidth="2px"
    >
      <path d="M40.6,25.7v-3.1h0c0-1.1.9-2,2.2-2.3l2.8-.6c-.5-2.8-1.6-5.4-3.1-7.7l-2.2,1.5c-1.1.8-2.5.8-3.3,0l-2.2-2.2c-.8-.8-.8-2.1,0-3.2l1.6-2.4c-2.3-1.5-4.9-2.7-7.7-3.2l-.5,2.7c-.2,1.4-1.2,2.4-2.3,2.4h-3.1c-1.1,0-2-.9-2.3-2.2l-.6-2.9c-2.8.5-5.5,1.6-7.8,3.2l1.6,2.4c.8,1.1.7,2.5,0,3.2l-2.2,2.2c-.8.8-2.2.8-3.3,0l-2.3-1.6c-1.5,2.3-2.6,4.9-3.2,7.7l2.9.6c1.3.3,2.2,1.2,2.2,2.3v3.1c0,1.1-1,2.1-2.4,2.3l-2.8.5c.6,2.8,1.7,5.4,3.2,7.7l2.5-1.6c1.1-.7,2.5-.7,3.2,0l2.2,2.2c.8.8.8,2.2,0,3.3l-1.6,2.3c2.3,1.5,4.9,2.6,7.7,3.2l.6-2.8c.3-1.3,1.2-2.2,2.3-2.2h3.1c1.1,0,2.1,1,2.3,2.4l.5,2.7c2.8-.6,5.3-1.7,7.6-3.1l-1.6-2.2c-.8-1.2-.8-2.5,0-3.3l2.2-2.2c.8-.8,2.1-.8,3.2,0l2.4,1.6c1.5-2.3,2.6-4.9,3.2-7.7l-2.6-.5c-1.4-.2-2.3-1.2-2.3-2.3ZM24,33c-5,0-9-4-9-9s4-9,9-9,9,4,9,9-4,9-9,9Z" />
    </svg>
  );
};
